import template from './vouches.html';
import controller from './vouches.controller';
import './vouches.styl';

let vouchComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default vouchComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/vouches/vouches.component.js
 **/